/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiWsBridgeAlertcallAnswerPost } from '../fn/ws-bridge/api-ws-bridge-alertcall-answer-post';
import { ApiWsBridgeAlertcallAnswerPost$Params } from '../fn/ws-bridge/api-ws-bridge-alertcall-answer-post';
import { apiWsBridgeAlertcallIdAnswersGet } from '../fn/ws-bridge/api-ws-bridge-alertcall-id-answers-get';
import { ApiWsBridgeAlertcallIdAnswersGet$Params } from '../fn/ws-bridge/api-ws-bridge-alertcall-id-answers-get';
import { apiWsBridgeAlertcallIdCountPagerPatch } from '../fn/ws-bridge/api-ws-bridge-alertcall-id-count-pager-patch';
import { ApiWsBridgeAlertcallIdCountPagerPatch$Params } from '../fn/ws-bridge/api-ws-bridge-alertcall-id-count-pager-patch';
import { apiWsBridgeAlertcallPost } from '../fn/ws-bridge/api-ws-bridge-alertcall-post';
import { ApiWsBridgeAlertcallPost$Params } from '../fn/ws-bridge/api-ws-bridge-alertcall-post';
import { MultipleResponseAnswersIrideGetDto } from '../models/multiple-response-answers-iride-get-dto';
import { SingleResponseAnswerIridePostDto } from '../models/single-response-answer-iride-post-dto';
import { SingleResponseIridePostDto } from '../models/single-response-iride-post-dto';

@Injectable({ providedIn: 'root' })
export class WsBridgeService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /** Path part for operation `apiWsBridgeAlertcallPost()` */
    static readonly ApiWsBridgeAlertcallPostPath = '/api/ws-bridge/alertcall';

    /**
     * Add a new alert call to the system (API Key required).
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `apiWsBridgeAlertcallPost()` instead.
     *
     * This method sends `Alert call to add` and handles request body of type `Alert call to add`.
     */
    apiWsBridgeAlertcallPost$Response(
        params: ApiWsBridgeAlertcallPost$Params,
        context?: HttpContext,
    ): Observable<StrictHttpResponse<SingleResponseIridePostDto>> {
        return apiWsBridgeAlertcallPost(this.http, this.rootUrl, params, context);
    }

    /**
     * Add a new alert call to the system (API Key required).
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `apiWsBridgeAlertcallPost$Response()` instead.
     *
     * This method sends `Alert call to add` and handles request body of type `Alert call to add`.
     */
    apiWsBridgeAlertcallPost(params: ApiWsBridgeAlertcallPost$Params, context?: HttpContext): Observable<SingleResponseIridePostDto> {
        return this.apiWsBridgeAlertcallPost$Response(params, context).pipe(
            map((r: StrictHttpResponse<SingleResponseIridePostDto>): SingleResponseIridePostDto => r.body),
        );
    }

    /** Path part for operation `apiWsBridgeAlertcallAnswerPost()` */
    static readonly ApiWsBridgeAlertcallAnswerPostPath = '/api/ws-bridge/alertcall/answer';

    /**
     * Add answer an alert call (API Key required).
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `apiWsBridgeAlertcallAnswerPost()` instead.
     *
     * This method sends `Answer to add` and handles request body of type `Answer to add`.
     */
    apiWsBridgeAlertcallAnswerPost$Response(
        params: ApiWsBridgeAlertcallAnswerPost$Params,
        context?: HttpContext,
    ): Observable<StrictHttpResponse<SingleResponseAnswerIridePostDto>> {
        return apiWsBridgeAlertcallAnswerPost(this.http, this.rootUrl, params, context);
    }

    /**
     * Add answer an alert call (API Key required).
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `apiWsBridgeAlertcallAnswerPost$Response()` instead.
     *
     * This method sends `Answer to add` and handles request body of type `Answer to add`.
     */
    apiWsBridgeAlertcallAnswerPost(
        params: ApiWsBridgeAlertcallAnswerPost$Params,
        context?: HttpContext,
    ): Observable<SingleResponseAnswerIridePostDto> {
        return this.apiWsBridgeAlertcallAnswerPost$Response(params, context).pipe(
            map((r: StrictHttpResponse<SingleResponseAnswerIridePostDto>): SingleResponseAnswerIridePostDto => r.body),
        );
    }

    /** Path part for operation `apiWsBridgeAlertcallIdAnswersGet()` */
    static readonly ApiWsBridgeAlertcallIdAnswersGetPath = '/api/ws-bridge/alertcall/:id/answers';

    /**
     * Get answers to an alert call (API Key required).
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `apiWsBridgeAlertcallIdAnswersGet()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiWsBridgeAlertcallIdAnswersGet$Response(
        params: ApiWsBridgeAlertcallIdAnswersGet$Params,
        context?: HttpContext,
    ): Observable<StrictHttpResponse<MultipleResponseAnswersIrideGetDto>> {
        return apiWsBridgeAlertcallIdAnswersGet(this.http, this.rootUrl, params, context);
    }

    /**
     * Get answers to an alert call (API Key required).
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `apiWsBridgeAlertcallIdAnswersGet$Response()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiWsBridgeAlertcallIdAnswersGet(
        params: ApiWsBridgeAlertcallIdAnswersGet$Params,
        context?: HttpContext,
    ): Observable<MultipleResponseAnswersIrideGetDto> {
        return this.apiWsBridgeAlertcallIdAnswersGet$Response(params, context).pipe(
            map((r: StrictHttpResponse<MultipleResponseAnswersIrideGetDto>): MultipleResponseAnswersIrideGetDto => r.body),
        );
    }

    /** Path part for operation `apiWsBridgeAlertcallIdCountPagerPatch()` */
    static readonly ApiWsBridgeAlertcallIdCountPagerPatchPath = '/api/ws-bridge/alertcall/:id/count-pager';

    /**
     * Update the count of pager for an alert call (API Key required).
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `apiWsBridgeAlertcallIdCountPagerPatch()` instead.
     *
     * This method sends `Answer to add` and handles request body of type `Answer to add`.
     */
    apiWsBridgeAlertcallIdCountPagerPatch$Response(
        params: ApiWsBridgeAlertcallIdCountPagerPatch$Params,
        context?: HttpContext,
    ): Observable<StrictHttpResponse<void>> {
        return apiWsBridgeAlertcallIdCountPagerPatch(this.http, this.rootUrl, params, context);
    }

    /**
     * Update the count of pager for an alert call (API Key required).
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `apiWsBridgeAlertcallIdCountPagerPatch$Response()` instead.
     *
     * This method sends `Answer to add` and handles request body of type `Answer to add`.
     */
    apiWsBridgeAlertcallIdCountPagerPatch(params: ApiWsBridgeAlertcallIdCountPagerPatch$Params, context?: HttpContext): Observable<void> {
        return this.apiWsBridgeAlertcallIdCountPagerPatch$Response(params, context).pipe(
            map((r: StrictHttpResponse<void>): void => r.body),
        );
    }
}
